function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

import get from 'lodash/get';
import isNil from 'lodash/isNil';
export var ACTION_POP = 'POP';
export var STORAGE_KEY = 'scrollRestorationCache';
export var ScrollRestorer = /*#__PURE__*/function () {
  function ScrollRestorer(generateRouteKey) {
    _classCallCheck(this, ScrollRestorer); // disable automatic scroll restoration


    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    this.generateRouteKey = generateRouteKey;

    try {
      var scrollPositions = sessionStorage.getItem(STORAGE_KEY);
      this.positions = !isNil(scrollPositions) ? JSON.parse(scrollPositions) : {};
    } catch (err) {
      console.debug('Error retrieving scroll positions from session storage; falling back to in-memory cache');
      this.positions = {};
    }
  }

  _createClass(ScrollRestorer, [{
    key: "update",
    value: function update(location, scrollY) {
      var routeKey = this.generateRouteKey(location);
      this.positions[routeKey] = scrollY; // save updated scroll position to session storage

      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(this.positions));
    }
  }, {
    key: "restore",
    value: function restore(_ref) {
      var action = _ref.action,
          location = _ref.location;
      var lastKnownScrollY = get(this.positions, this.generateRouteKey(location), 0); // only restore scroll position to last known value if action is "POP"
      // (back/forward navigation actions)

      var scrollY = action === ACTION_POP ? lastKnownScrollY : 0;
      requestAnimationFrame(function () {
        window.scrollTo(0, scrollY);
      });
    }
  }]);

  return ScrollRestorer;
}();
export default ScrollRestorer;